import { defineProtocolIdSetStore } from './protocol-id-set';

/** Ids of protocols seen as synced from V1. */
export const useSyncedProtocols = defineProtocolIdSetStore('syncedProtocols');
